import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import Button from "../Button";
import {getRandomColor} from "../../utils/GetRandomColor";
import "../../styles/Carousel.css"

export default function Carousel({images = []}) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    if (!images || images.length === 0) {
        return <div className="carousel-component">No images to display</div>;
    }

    const carouselImageStyle = {
        width: '100%',
        objectFit: 'cover',
    };
    
    return (
        <div className="carousel-component" style={{backgroundColor: getRandomColor()}}>
            <div className="carousel-wrapper">
                <button className="carousel-button carousel-button-left" onClick={goToPrevious}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>

                <div className="carousel-image-container">
                    <img
                        style={carouselImageStyle}
                        src={images[currentIndex]}
                        alt={`Slide ${currentIndex + 1}`}
                        className="carousel-image"
                    />
                </div>

                <button className="carousel-button carousel-button-right" onClick={goToNext}>
                    <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>

            <div className="carousel-dots">
                {images.map((_, index) => (
                    <button key={index}
                            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}>
                    </button>
                ))}
            </div>
        </div>
    )
}